.select-input-container {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 15rem;
  z-index: 99;
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  svg {
    fill: var(--white-default);
    width: 1.6rem;
    position: absolute;
    right: 1.6rem;
  }

  &[data-small='true'] {
    svg {
      right: 0.8rem;
    }
  }

  &[data-medium='true'] {
    height: 3.2rem;

    svg {
      right: 0.8rem;
    }
  }

  &[data-disabled='true'] {
    &:hover {
      color: var(--deprecated-grey-dark);
      cursor: no-drop;
    }
  }
}

.label {
  font-family: Inter, sans-serif;
  font-weight: 600;
  color: var(--text-color-white);
  font-size: 1.4rem;
  letter-spacing: 0.7px;
  line-height: 1.1rem;
  display: inline;
  margin-bottom: 0.8rem;
}

.input {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 3.2rem;
  border-radius: 0.8rem;
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  line-height: 1.6rem;
  display: flex;
  z-index: 1;
  align-items: center;
  border: 1px solid var(--select-border-color);
  color: var(--select-text-color);
  background-color: var(--deprecated-grey-background);
  /* The original declared border and height twice; kept in order so the later
     value still wins. */
  border: none;
  height: 40px;

  /* Was `(small || medium) && css\`border-radius: 0.4rem\`` */
  &[data-small='true'],
  &[data-medium='true'] {
    border-radius: 0.4rem;
  }

  &:focus {
    outline: none;
    border: 1px solid var(--deprecated-grey-lightest);
    color: var(--white-default);
  }

  &[data-disabled='true'] {
    color: var(--deprecated-grey-dark);
    cursor: no-drop;

    svg {
      fill: var(--color-text-grey-dark);
      stroke: var(--color-text-grey-dark);
    }
  }

  &[data-has-error='true'] {
    &:focus {
      border: 1px solid var(--color-error);
      color: var(--color-error);
    }
  }
}

.text {
  position: relative;
  padding-left: 1.6rem;
  padding-right: 2.8rem;
  color: var(--text-color-white);
  font-size: 1.4rem;
  letter-spacing: 0.3px;
  line-height: 1.6rem;
  min-width: 12rem;

  &[data-has-error='true'] {
    color: var(--color-error);
  }

  &[data-disabled='true'] {
    color: var(--color-text-grey-dark);
    cursor: no-drop;
  }
}

.option {
  position: absolute;
  top: 5.2rem;
  width: 100%;
  right: 0;
  font-family: Inter, sans-serif;
  display: flex;
  align-items: center;
  color: var(--text-color-white);
  background-color: var(--card-bg-color);
  transform: translateY(-2rem);

  &[data-small='true'] {
    top: 4.2rem;
  }

  /* Must stay after [data-small]: the original ternary tested `medium` first,
     so medium wins when both are set. */
  &[data-medium='true'] {
    top: 5rem;
  }

  ul {
    overflow-y: auto;
    /* maxHeight defaults to 30 in the component and is also used in its layout
       maths, so it is always defined and always set inline. */
    max-height: var(--option-max-height);
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    padding-left: 0.8rem;
    height: 2.5rem;
    line-height: 2.5rem;
    font-size: 1.2rem;
    letter-spacing: 0.3px;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    margin-top: 0;
    -webkit-box-orient: vertical;
  }

  li:hover {
    cursor: pointer;
    background-color: var(--color-secondary);
  }
}

.error {
  position: relative;
  right: 0;
  height: 1.6rem;
  color: var(--color-error);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: -0.2px;
  line-height: 1.6rem;
  text-align: right;
  z-index: -2;

  svg {
    fill: var(--white-default);
    width: 1.6rem;
    position: absolute;
    right: 1.6rem;
    top: 0.8rem;
    bottom: 0.8rem;
  }
}
